module.exports = __webpack_public_path__ + "static/logo-chmura-krajowa-a7650aa5a310a993fec4eabba08c11c9.svg";